import Table from 'rsuite/Table';
import 'rsuite/Table/styles/index.css';
import Badge from "rsuite/Badge";
import 'rsuite/Badge/styles/index.css';
import {ProgressBar, OverlayTrigger, Tooltip, Modal} from "react-bootstrap";
import dayjs from "dayjs";
import { useAuth } from "../../../components/auth/request/AuthProvider";
import { useState } from "react";
import { useToast } from "../../../components/notificaciones/ToastProvider";
import {axiosInstance} from "../../../components/helpers/axiosInstance";
import {Grid} from "rsuite";
import 'rsuite/Grid/styles/index.css';
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import MiembrosMap from "../../../components/helpers/MiembrosMap";
import { PrioridadIcon } from "../../../components/catalogo/CatalogosTareas";
import { estatusColor } from "../../../components/catalogo/EstatusTask";
const { Column, HeaderCell, Cell } = Table;

export default function VistaArbol({
    task,
    toggleShow
}) {

    return (
        <>
            <style type={"text/css"}>
                {`
                    .rs-table-cell-content{
                        display: flex;
                    }
                    
                    .progress-bar {
                        padding-top : 0.15rem;
                    }
                    
                    .rs-table-cell-content{
                        align-items: center!important;
                    }
                    
                    .rs-table:not(.rs-table-has-rowspan) .rs-table-row{
                        border-bottom:1px dashed var(--bs-gray-300)!important;
                    }
                    
                    .rs-table-cell-expand-wrapper{
                        align-self: start;
                        margin-top: -0.25rem;
                    }
                `}
            </style>
            <Grid fluid={true}>
                <Table
                    virtualized={true}
                    isTree
                    height={750}
                    data={task}
                    rowHeight={60}
                    rowKey={"id_tarea"}
                    defaultExpandAllRows={true}
                    renderTreeToggle={(expandButton, rowData) => {
                        if (rowData.children && rowData.children.length > 0) {
                            return(<i className={"bi bi-caret-right-fill text-dark fs-9" }></i>);
                        }
                    }}
                >
                    <Column minWidth={35} width={40} verticalAlign={'middle'}>
                        <HeaderCell></HeaderCell>
                        <Cell>
                            {
                                rowData => {
                                    return(
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex flex-column text-center">
                                                {
                                                    rowData.archivos_adjuntos === true && <div>
                                                        <TitleTooltip title={"El proyecto contiene archivos adjuntos"} placement={'top'}>
                                                            <i className="ki-solid ki-paper-clip fs-3 text-primary"></i>
                                                        </TitleTooltip>
                                                    </div>}
                                                {
                                                    (rowData.comentarios && rowData.comentarios.length > 0) &&
                                                    <div className="d-block">
                                                        <VistasComentarios comentarios={rowData.comentarios}></VistasComentarios>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    );
                                }
                            }
                        </Cell>
                    </Column>
                    <Column width={30} minWidth={25}>
                        <HeaderCell></HeaderCell>
                        <Cell>
                            {
                                rowData => {
                                    return(
                                        rowData.recordatorio.slice(0, 10) === dayjs().format('YYYY-MM-DD') && <TitleTooltip title={"La tarea está por expirar"} placement={'top'}><i className="bi bi-alarm-fill fs-6 text-primary"></i></TitleTooltip>
                                    );
                                }
                            }
                        </Cell>
                    </Column>
                    <Column width={20} minWidth={15}>
                        <HeaderCell></HeaderCell>
                        <Cell>
                            {
                                rowData => {
                                    return(
                                        <PrioridadIcon classB={rowData.prioridad}></PrioridadIcon>
                                    );
                                }
                            }
                        </Cell>
                    </Column>
                    <Column flexGrow={5} treeCol>
                        <HeaderCell className={"fs-base fw-bold text-muted"}>TAREA</HeaderCell>
                        <Cell>
                            {
                                rowData => {
                                    return(
                                        <div className={"d-flex text-nowrap overflow-hidden fs-6"}>
                                            <div className={'d-flex flex-column'}>
                                                <button
                                                    type={'button'}
                                                    className="btn btn-link p-0 text-start text-uppercase text-gray-900 text-hover-primary fs-6 fw-semibold"
                                                    onClick={(e) => toggleShow(e, rowData.id_tarea, rowData.tarea)}>
                                                    {rowData.tarea}
                                                </button>
                                                <span className="d-block text-muted fs-6" style={{marginTop: 0.10 + "rem"}}>{rowData.objetivo}</span>
                                            </div>
                                        </div>
                                    );
                                }
                            }
                        </Cell>
                    </Column>
                    <Column width={150}>
                        <HeaderCell className={"fs-base fw-bold text-muted"}> MIEMBROS ️</HeaderCell>
                        <Cell>
                            {
                                rowData => {
                                    return (
                                        <div className="symbol-group symbol-hover">
                                            {
                                                rowData.miembros && rowData.miembros.map((m, index) => {
                                                    return ( index < 4 && <MiembrosMap key={m.usuario} user={m.usuario} avatar={m.avatar}></MiembrosMap>);
                                                })
                                            }
                                            {
                                                rowData.miembros && rowData.miembros.length > 4 &&
                                                <OverlayTrigger overlay={totalMiembros(rowData.miembros)}  placement="right" delay={{ show: 250, hide: 400 }}>
                                                    <div className={"symbol symbol-35px symbol-circle"}>
                                                        <span className={"symbol-label fw-bold fs-8 text-white bg-dark"}>+{rowData.miembros.length}</span>
                                                    </div>
                                                </OverlayTrigger>
                                            }
                                        </div>
                                    );
                                }
                            }
                        </Cell>
                    </Column>
                    <Column width={150}>
                        <HeaderCell className={"fs-base fw-bold text-muted"}> INICIO </HeaderCell>
                        <Cell>
                            {
                                rowData => rowData.inicio_proyectado && <span className={"fw-semibold d-block mb-1 fs-6 text-capitalize"}>{ dayjs(rowData.inicio_proyectado.slice(0,10)).format('MMM DD, YYYY')}</span>
                            }
                        </Cell>
                    </Column>
                    <Column width={150}>
                        <HeaderCell className={"fs-base fw-bold text-muted"}> FIN </HeaderCell>
                        <Cell>
                            {
                                rowData => rowData.termino_proyectado && <span className={"fw-semibold d-block mb-1 fs-6 text-capitalize"}>{dayjs(rowData.termino_proyectado.slice(0,10)).format('MMM DD, YYYY')}</span>
                            }
                        </Cell>
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell className={"fs-base fw-bold text-muted"}>PROGRESO</HeaderCell>
                        <Cell>
                            {
                                rowData => <TitleTooltip title={'Estatus: ' + rowData.estatus} placement={'top'}>
                                    <ProgressBar now={rowData.progreso} label={`${rowData.progreso}%`} variant={estatusColor(rowData.estatus)} style={{width: "100%"}}/>
                                </TitleTooltip>
                            }
                        </Cell>
                    </Column>
                    <Column width={75} align={'right'}>
                        <HeaderCell></HeaderCell>
                        <Cell style={{padding: '0.25rem'}}>
                            {
                                rowData => <DeleteTask id={rowData.id_tarea}></DeleteTask>
                            }
                        </Cell>
                    </Column>
                </Table>
            </Grid>
        </>
    );
}


export function totalMiembros(miembros){
    return (
        <Tooltip>
            {
                miembros && miembros.map((m) => {
                    return (
                        <div key={m.avatar}
                             className={"d-flex py-3 border-bottom border-gray-300 border-bottom-dashed align-item-center"}>
                            <button
                                type={'button'}
                                className={"btn p-0 d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary text-capitalize"}>
                                {m.usuario}
                                <span className={"badge badge-light fs-8 fw-semibold ms-2"}>{m.rol}</span>
                            </button>
                        </div>
                    );
                })
            }
        </Tooltip>
    );
}
/**
 *
 * @param comentarios, arregl de comentarios en el proyecto.
 * @returns {JSX.Element}
 * @constructor
 */
export function VistasComentarios({
    comentarios,
}){

    const { user } = useAuth();
    const id = user.usuario.id_usuario;
    let cuenta = comentarios.length;
    /**
     * @param c.vistas
     */
    comentarios.forEach((c) => {
        if (c.vistas.some((n) => n.id_usuario === id)){
            cuenta = cuenta - 1;
        }
    })

    if (cuenta > 0) {
        return(
            <Badge content={cuenta} className={"mx-2"}>
                <TitleTooltip title={"Hay nuevos comentarios"} placement={'top'}>
                    <i className="bi bi-chat-left fs-5 text-primary"></i>
                </TitleTooltip>
            </Badge>
        );
    }
}

export function DeleteTask({
    id
}){

    const [show, setShow] = useState(false);
    const toast = useToast();

    function handleDeleteTask(){
        axiosInstance.delete('/todo/tareas/', {
            data : {
                id_tarea: id
            }
        }).then((res) => {
            if (res.status === 200){
                setShow(false);
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id : id,
                            text : 'La tareas se ha eliminado',
                            color : 'success',
                            show : true
                        }
                    ]
                );
            }
        }).catch((err) => {
            setShow(false);
            toast.setArrayToast(
                prevState => [
                    ...prevState,
                    {
                        id : id,
                        text : 'Hubo un error:' + err.data,
                        color : 'danger',
                        show : true
                    }
                ]
            );
        })
    }

    return (
        <>
            <TitleTooltip title={"Eliminar tarea"} placement={'top'}>
                <button type={'button'} className="btn btn-sm btn-light-danger btn-icon"
                        onClick={() => setShow(true)}>
                    <i className="ki-solid ki-trash fs-5"></i>
                </button>
            </TitleTooltip>

            <Modal show={show} onHide={() => setShow(false)} backdrop="static" keyboard={false}>
                <Modal.Body className={"fs-3 align-content-center"}>
                    <i className="bi bi-exclamation-circle fs-1 me-5 text-danger"></i>
                    ¿Eliminar tarea?
                </Modal.Body>
                <Modal.Footer className={"p-2"}>
                    <button type={"button"} className={"btn btn-outline btn-outline-secondary btn-active-light-secondary me-8"} onClick={() => setShow(false)}>
                        Cerrar
                    </button>
                    <button type={"button"} className={"btn btn-outline btn-outline-primary btn-active-light-primary me-8"} onClick={handleDeleteTask}>
                        Confirmar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
